module.exports = __WEBPACK_EXTERNAL_MODULE_112__;


//////////////////
// WEBPACK FOOTER
// external "jquery"
// module id = 112
// module chunks = 0